const phoneNumberErrorMessages = {
  US: 'Please provide a valid <countryCode> telephone number',
  GB: 'Please provide a valid <countryCode> telephone number',
  CS: 'Uveďte platné telefonní číslo v <countryCode>',
  DA: 'Angiv et gyldigt <countryCode> telefonnummer',
  DE: 'Bitte geben Sie eine gültige <countryCode> Telefonnummer an',
  ES: 'Indique un teléfono válido de <countryCode>',
  FI: 'Anna voimassa oleva <countryCode> puhelinnumero',
  FR: 'Veuillez indiquer un numéro de téléphone valide pour la <countryCode>',
  IT: 'Fornisci un numero di telefono <countryCode> valido',
  NB: 'Please provide a valid <countryCode> telephone number',
  NL: 'Geef een geldig <countryCode> telefoonnummer op',
  PL: 'Proszę podać poprawny numer telefonu dla <countryCode>',
  PT: 'Indique um número de telefone <countryCode> válido',
  SV: 'Ange ett giltigt <countryCode> telefonnummer',
};

const getPhoneNumberErrorMessage = (countryCode) => {
  const message = phoneNumberErrorMessages[countryCode]
    ? phoneNumberErrorMessages[countryCode]
    : phoneNumberErrorMessages.GB;
  return message.replace('<countryCode>', countryCode);
};

/**
 * True when the phone country has genuinely changed, rather than the mount-time
 * re-init that fires the change handler with the same country. Case-insensitive,
 * and defensive against a missing/invalid previous country so a bad value never
 * arms the flag-driven refetch hold.
 */
export const isActualCountryChange = (
  previousCountryOption,
  newCountryISOCode
) =>
  typeof previousCountryOption?.code === 'string' &&
  typeof newCountryISOCode === 'string' &&
  previousCountryOption.code.toUpperCase() !== newCountryISOCode.toUpperCase();

export default getPhoneNumberErrorMessage;
